// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"792":"main","884":"admin"}[chunkId] + "." + {"792":"47fee1e3b619f31686e0","884":"ecac6eac9ef252d03b37"}[chunkId] + ".css";
};